export default __webpack_public_path__ + "63d06c0cddbc62cafe171297a114ccf1.png";